"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var asg_1 = require("@alinta-digital/asg");
var react_1 = tslib_1.__importDefault(require("react"));
var DueDate_1 = tslib_1.__importDefault(require("../DueDate"));
var TotalBalanceAmt_1 = tslib_1.__importDefault(require("../TotalBalanceAmt"));
var TotalBalanceLabel_1 = tslib_1.__importDefault(require("../TotalBalanceLabel"));
var BalanceDueAccountBalance = function (props) {
    var totalBalance = props.totalBalance, dueDate = props.dueDate, hasDirectDebit = props.hasDirectDebit, hasSmoothPay = props.hasSmoothPay;
    var dueDateProps = {
        dueDate: dueDate,
        hasDirectDebitSetup: hasDirectDebit && !hasSmoothPay,
    };
    return (react_1.default.createElement(asg_1.Box, { direction: "row" },
        react_1.default.createElement(asg_1.Box, { width: "50%", alignSelf: "start" },
            react_1.default.createElement(TotalBalanceLabel_1.default, null),
            react_1.default.createElement(DueDate_1.default, tslib_1.__assign({}, dueDateProps))),
        react_1.default.createElement(asg_1.Box, { width: "50%", direction: "row" },
            react_1.default.createElement(TotalBalanceAmt_1.default, { totalBalance: totalBalance }))));
};
exports.default = BalanceDueAccountBalance;
//# sourceMappingURL=BalanceDueAccountBalance.js.map